import { monitorValue } from "../../util/monitorUtils";
const buildFireMatrixData = (monitor) => {

    const matrix = {};

    for (let car = 1; car <= 8; car++) {

        matrix[car] = {

            falhaSistema:
                monitorValue(
                    monitor,
                    `falhaSistemaCarro${car}`,
                    0
                ) !== 0,

            falhaSistemaCategory:
                monitor?.[
                    `falhaSistemaCarro${car}`
                ]?.category,

            alarmeIncendio:
                monitorValue(
                    monitor,
                    `alarmeIncendioCarro${car}`,
                    0
                ) !== 0,

            alarmeIncendioCategory:
                monitor?.[
                    `alarmeIncendioCarro${car}`
                ]?.category

        };
    }

    return matrix;
};
export default buildFireMatrixData;